/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable arrow-body-style */
import ModalSelect from 'components/modal-select';
import Chevron from 'components/Chevron';
import Check from 'components/Check';
import { IOption } from 'domains/quotation/constants/banks';
import useOnClickOutside from 'libs/hooks/useOnClickOutside';
import useWindowSize from 'libs/hooks/useWindowSize';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import './combo-box.scss';

export interface ICombo {
  selected: any;
  options: any;
  onChange: any;
  id: string;
  label?: string;
  placeholder?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  message?: string;
}

const ComboBox: React.FC<ICombo> = (props: ICombo) => {
  const {
    selected,
    options,
    onChange,
    label = '',
    id,
    placeholder = '',
    className = '',
    required = false,
    disabled = false,
    message = '',
  } = props;
  const { isMobile } = useWindowSize(960);
  const [isOpen, setIsOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const boxBodyRef = useRef(null);
  const modalBodyRef = useRef(null);
  const openBoxBody = useMemo(
    () => options.length > 0 && isOpen && !isMobile,
    [options, isOpen, isMobile],
  );

  const handleChange = (option: IOption) => {
    onChange(option);
    setIsOpen(false);
    if (isMobile) setOpenModal(false);
  };

  useEffect(() => {
    if (isMobile && isOpen) setOpenModal(true);
  }, [isMobile, isOpen]);

  const handleClickOutsideBoxBody = () => {
    if (openBoxBody) setIsOpen(false);
  };

  const handleClickOutsideModalBody = () => {
    setOpenModal(false);
    setIsOpen(false);
  };

  useOnClickOutside(boxBodyRef, handleClickOutsideBoxBody);
  useOnClickOutside(modalBodyRef, handleClickOutsideModalBody);

  /*
   * validators
   */
  const [touched, setTouched] = useState(false);
  const validatorMsg =
    touched && required && !selected ? 'Debe seleccionar una opción' : '';
  /*
   * end validators
   */

  return (
    <>
      <ModalSelect
        hasClose={false}
        isOpen={openModal}
        className="ui-combo-box__modal"
        modalRef={modalBodyRef}
      >
        <ul className="ui-combo-box__body">
          {options.map((option: any) => (
            <li
              key={option.value}
              className={
                selected && selected.value === option.value ? 'selected' : ''
              }
              onClick={() => handleChange(option)}
            >
              <p>{option.label}</p>
              <Check
                isSelected={selected && selected.value === option.value}
                className="ui-combo-box__check"
              />
            </li>
          ))}
        </ul>
      </ModalSelect>

      <div
        id={`ui-combo-${id}`}
        className={`ui-combo-box  ${className || ''} ${validatorMsg ? 'ui-combo-box--invalid' : ''
          } ${disabled ? 'disabled' : ''}`}
        data-testid="combo-box"
      >
        {label ? <label htmlFor={id}>{label}</label> : null}
        <div className="ui-combo-box__dropdown" ref={boxBodyRef}>
          <div
            onClick={() => {
              if (disabled) return;

              !touched && setTouched(true);
              setIsOpen(!isOpen);
            }}
            className="ui-combo-box__selection"
          >
            <input
              type="text"
              readOnly
              value={selected && selected.label}
              placeholder={placeholder}
            />
            <Chevron
              name={isOpen ? 'up-mob' : 'down-mob'}
              width={24}
              height={20}
              fill={isOpen ? '#0099cc' : '#BABABA'}
            />
          </div>
          <ul
            className={`ui-combo-box__body ${openBoxBody ? 'show-box' : 'hide-box'
              }`}
          >
            {options.map((option: any) => (
              <li
                key={option.value}
                className={
                  selected && selected.value === option.value ? 'selected' : ''
                }
                onClick={() => handleChange(option)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
        {message && <p className="ui-combo-box__footer_msg">{message}</p>}
        {required && (
          <p className="ui-combo-box__invalid_msg">{validatorMsg}</p>
        )}
      </div>
    </>
  );
};


export default ComboBox;
